
// @group components

export default {
  name: 'IntroAbout',
  props: ['data']
}
